function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchCodeTypesThunk, fetchNetworkEventTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import * as SessionSelectors from 'invision-core/src/components/session/session.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { stateGo } from 'redux-ui-router';
import { ACCOUNTING_METHOD_TYPES } from '../../../customercare.constants';
import LocaleKeys from '../../../locales/keys';
import { createConvergentBillerAdjustment, retrieveAndOpenConvergentBillerLedgerInvoice, retrieveLedgerInvoiceDetails, retrieveLedgerSummary, setPageSizePreference, updatePageNumber } from '../../../reducers/actions/customer.billing.actions';
import { DASHBOARD_ROUTE } from '../../../reducers/constants/dashboard.constants';
import { AdjustmentConfigSelector, CombinedBillingCurrencyCodeSelector, InvoiceDetailsPageCountSelector, InvoiceDetailsRecordCountSelector, InvoiceDetailsSummarySelector, InvoiceItemsTableDataSelector, InvoiceSummaryByIdSelector, IsFetchingInvoiceContentSelector, IsFetchingInvoiceDetailsSelector, PageNumberSelector, PageSizeSelector, SelectedPageSizePreference } from '../../../reducers/selectors/customer.billing.selectors';
import { IsCurrentAccountPostpaidSelector, IsFetchingSubscriberSummarySelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentCustomerAccountingMethodSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerNameSelector, IsPIIDataAccessEnabledSelector, RouteParams } from '../../../reducers/selectors/customer.selectors';
import { ALLOW_CREDIT_DEBIT_NOTE, ONE_TIME_MAKE_PAYMENT, PAYMENT_ADJUSTMENT_ACCESS } from '../../../security.attributes';
import { BILL_ADJUSTMENT } from '../../adjustment/adjustment.modal.constants';
import { ACCOUNTING_METHODS } from '../../createCustomer/billingInformationSection/billing.information.section.constants';
import { CASE_CATEGORIES } from '../../customer/cases/list/case.constants';
import MakePaymentConstants, { MAKE_PAYMENT_ROUTE } from '../../customer/makePayment/make.payment.constants';
import * as BillingPaymentsConstants from '../billing.payments.constants';
import { BILLING_INVOICE_LIST_URL, FUTURE_INVOICE_URL } from '../billing.payments.constants';
import * as DETAILS_CONSTANTS from './detail.constants';
var BillingPaymentsInvoiceController = /*#__PURE__*/function () {
  function BillingPaymentsInvoiceController($ngRedux, $state, $stateParams, $filter, $scope, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, BillingPaymentsInvoiceController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $stateParams: $stateParams,
      $filter: $filter,
      $scope: $scope,
      $timeout: $timeout,
      ACCOUNTING_METHODS: ACCOUNTING_METHODS,
      LocaleKeys: LocaleKeys,
      ADJUSTMENT_TYPE: BillingPaymentsConstants.OVERALL,
      DUE_DATE: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DUE_DATE),
      futureInvoiceHasError: false,
      goToMakePayment: this.goToMakePayment.bind(this),
      hasMakeAPaymentAccess: this.hasMakeAPaymentAccess.bind(this),
      handleMoreMenuOptions: this.handleMoreMenuOptions.bind(this),
      handleConvertToCreditModalClose: this.handleConvertToCreditModalClose.bind(this),
      onConvertToCreditFormSubmit: this.onConvertToCreditFormSubmit.bind(this),
      onConvertToCreditFormError: this.onConvertToCreditFormError.bind(this),
      goBack: this.goBack.bind(this),
      moreMenuOptions: [],
      isInvoiceAmountNegative: false,
      isConvertToCreditModalOpen: false,
      isOpenInvoice: false,
      isReceivablesModalOpen: false,
      INVOICE_BILL_DATES: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_BILL_DATES),
      INVOICE_DETAILS: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_DETAILS),
      INVOICE_NUMBER: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_NUMBER),
      INVOICE_SUMMARY: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_SUMMARY),
      LOADING: i18n.translate(LocaleKeys.LOADING),
      MAKE_A_PAYMENT: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.MAKE_A_PAYMENT),
      MORE: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.MORE),
      INVOICE_TYPE: MakePaymentConstants.MAKE_PAYMENT_TYPES.INVOICE,
      onReceivablesModalClose: this.onReceivablesModalClose.bind(this),
      receivables: [],
      stateOrName: 'index.customercare.customer.billingpayments.detail',
      searchTerm: '',
      tableData: {
        data: [],
        columnDefs: []
      },
      onPageSizeOptionSelected: this.onPageSizeOptionSelected.bind(this),
      onSearchCleared: this.onSearchCleared.bind(this),
      onSearchInvoiceItem: this.onSearchInvoiceItem.bind(this),
      openApplyTaxCertificateModal: this.openApplyTaxCertificateModal.bind(this),
      onApplyTaxCertificateModalClose: this.onApplyTaxCertificateModalClose.bind(this),
      updatePage: this.updatePage.bind(this),
      withheldTaxesApplicable: false,
      adjustmentModalConfig: {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.adjustmentModalApi = api;
        }
      },
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(BillingPaymentsInvoiceController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentConfig: AdjustmentConfigSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currencyCode: CombinedBillingCurrencyCodeSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          currentCustomerName: CurrentCustomerNameSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          invoiceSummary: InvoiceSummaryByIdSelector(store),
          featureTogglesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          isCurrentAccountPostpaid: IsCurrentAccountPostpaidSelector(store),
          isDbss: IsDbss(store),
          isFetchingAccountSummary: IsFetchingSubscriberSummarySelector(store),
          isFetchingInvoiceDetails: IsFetchingInvoiceDetailsSelector(store),
          isFetchingInvoiceContent: IsFetchingInvoiceContentSelector(store),
          isInvoiceItemTypeLoaded: MetadataCodeLoadedSelector(CODES.InvoiceItemType, store),
          networkEventTypeCodesLoaded: MetadataCodeLoadedSelector(CODES.NetworkEventType, store),
          routeParams: RouteParams(store),
          serviceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          tableData: InvoiceItemsTableDataSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          invoiceDetailsSummary: InvoiceDetailsSummarySelector(store),
          pageCount: InvoiceDetailsPageCountSelector(store),
          recordCount: InvoiceDetailsRecordCountSelector(store),
          selectedPageSizePreference: SelectedPageSizePreference(store),
          userPageSizePreference: PageSizeSelector(store),
          pageNumber: PageNumberSelector(store),
          lastRoute: SessionSelectors.LastRouteSelector(store)
        };
      };
      var controllerActions = {
        createConvergentBillerAdjustment: createConvergentBillerAdjustment,
        fetchCodeType: fetchCodeTypesThunk,
        fetchNetworkEventTypes: fetchNetworkEventTypes,
        retrieveInvoiceAndOpenInNewTab: retrieveAndOpenConvergentBillerLedgerInvoice,
        retrieveLedgerInvoiceDetails: retrieveLedgerInvoiceDetails,
        retrieveLedgerSummary: retrieveLedgerSummary,
        setPageSizePreference: setPageSizePreference,
        stateGo: stateGo,
        updatePageNumber: updatePageNumber
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.defaultBackRoute = FUTURE_INVOICE_URL;
      this.listPageRoute = BILLING_INVOICE_LIST_URL;
      this.INVOICE_HEADER = this.state.routeParams.isFutureInvoice ? i18n.translate(LocaleKeys.UPCOMING_INVOICE) : i18n.translate(LocaleKeys.INVOICE);
      this.AMOUNT_DUE = this.state.routeParams.isFutureInvoice ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.ESTIMATED_AMOUNT_DUE) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.AMOUNT_DUE);
      this.INVOICE_AMOUNT = this.state.routeParams.isFutureInvoice ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.ESTIMATED_INVOICE_AMOUNT) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_AMOUNT);
      this.invoiceId = this.state.routeParams.invoiceId;
      if (this.ACCOUNTING_METHODS[this.state.currentCustomerAccountingMethod].value === ACCOUNTING_METHOD_TYPES.OPEN_INVOICE) {
        this.isOpenInvoice = true;
      }
      if (!this.state.networkEventTypeCodesLoaded) {
        this.actions.fetchNetworkEventTypes();
      }
      if (!this.state.serviceAttributesLoaded) {
        this.actions.fetchCodeType(CODES.ServiceAttribute);
      }
      if (!this.state.featureTogglesLoaded) {
        this.actions.fetchCodeType(CODES.FeatureToggleConfig);
      }
      if (!this.state.isInvoiceItemTypeLoaded) {
        this.actions.fetchCodeType(CODES.InvoiceItemType);
      }
      this.actions.fetchCodeType(CODES.AdjustmentConfig).then(function () {
        _this2.updateInvoiceSummary();
        _this2.setMoreMenuOptions();
      });
      this.optionalParams = {
        customerId: this.state.currentCustomerId,
        invoiceId: this.state.routeParams.invoiceId
      };
      if (!this.state.selectedPageSizePreference) {
        this.actions.setPageSizePreference(this.state.userPageSizePreference);
      }
      if (!this.state.routeParams.isFutureInvoice) {
        this.retrieveLedgerInvoiceDetails().then(function () {
          _this2.updateInvoiceSummary();
        });
      } else {
        this.retrieveLedgerInvoiceDetails();
      }

      // wait for account summary to load due to dependency in more options
      this.$scope.$watch(function () {
        return _this2.state.isFetchingAccountSummary;
      }, function (newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          _this2.setMoreMenuOptions();
        }
      });
      this.applyTaxCertificateModalConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.applyTaxCertificateModalApi = api;
        }
      };
      this.openDialog = function (itemId, itemText, totalCharge, accountNumber) {
        _this2.adjustmentType = BILL_ADJUSTMENT;
        _this2.adjustmentModal = {
          accountNumber: accountNumber,
          invoiceId: _this2.state.routeParams.invoiceId,
          itemId: itemId,
          itemText: itemText,
          maxAmount: totalCharge,
          referenceId: _this2.state.invoiceDetailsSummary.InvoiceNumber
        };
        _this2.showAdjustmentModal = true;
        _this2.$timeout(function () {
          _this2.adjustmentModalApi.open();
        });
      };
      this.caseModalProps = {
        isOpen: false,
        onClose: function onClose() {
          _this2.caseModalProps.isOpen = false;
        },
        onSubmit: function onSubmit() {
          _this2.caseModalProps.isOpen = false;
          _this2.uiNotificationService.success(i18n.translate(LocaleKeys.CASE.CREATED_SUCCESSFULLY));
          _this2.retrieveLedgerInvoiceDetails();
          _this2.actions.retrieveLedgerSummary({
            customerId: _this2.state.currentCustomerId,
            request: {
              Filter: BillingPaymentsConstants.INVOICES
            }
          }).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          });
        },
        openCaseModal: function openCaseModal(invoiceItemId, invoiceItemBalance, invoiceItemMaxDisputableAmount) {
          _this2.caseModalProps.disputeDetails.selectedInvoiceId = _this2.state.invoiceDetailsSummary.InvoiceId;
          _this2.caseModalProps.disputeDetails.selectedInvoiceNumber = _this2.state.invoiceDetailsSummary.InvoiceNumber;
          _this2.caseModalProps.disputeDetails.selectedInvoiceItemId = invoiceItemId;
          _this2.caseModalProps.disputeDetails.selectedInvoiceItemBalance = invoiceItemBalance;
          _this2.caseModalProps.disputeDetails.selectedInvoiceMaxDisputableAmount = invoiceItemMaxDisputableAmount;
          _this2.caseModalProps.isOpen = true;
        },
        disputeDetails: {
          selectedInvoiceId: '',
          selectedInvoiceNumber: '',
          selectedInvoiceItemId: '',
          selectedInvoiceItemBalance: '',
          selectedInvoiceMaxDisputableAmount: ''
        },
        caseTemplateId: CASE_CATEGORIES.LINE_ITEM_DISPUTE,
        routeParams: {
          customerId: this.state.currentCustomerId
        }
      };
      this.$scope.VIEW_DETAILS = i18n.translate(LocaleKeys.VIEW_DETAILS);
      this.$scope.LINE_ITEM_HAS_DISPUTE = i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.LINE_ITEM_HAS_DISPUTE);
      this.$scope.handleMoreOptionSelected = function (item, action) {
        if (action.item.id === 'DISPUTE_LINE_ITEM') {
          _this2.caseModalProps.openCaseModal(item.invoiceItemId, item.invoiceItemBalance, item.invoiceItemMaxDisputableAmount);
        } else if (action.item.id === 'APPLY_ITEM_ADJUSTMENT') {
          _this2.openDialog(item.itemId, item.subscriberItem, item.totalChargeForApplyAdjustment, item.accountNumber);
        } else {
          var STATE_OR_NAME_NEW = 'index.customercare.customer.cases.detailsRedirect';
          _this2.actions.stateGo(STATE_OR_NAME_NEW, {
            customerId: _this2.state.currentCustomerId,
            caseId: item.caseId
          });
        }
      };
    }
  }, {
    key: "hasApplyTaxCertificateAccess",
    value: function hasApplyTaxCertificateAccess() {
      return this.state.isDbss && this.state.adjustmentConfig[BillingPaymentsConstants.ENABLE_CREATE_NOTE] === BillingPaymentsConstants.ADJUSTMENT_CONFIG_ENABLED && hasAccess(this.state.userSecurityAttributes, ALLOW_CREDIT_DEBIT_NOTE);
    }
  }, {
    key: "setMoreMenuOptions",
    value: function setMoreMenuOptions() {
      var _this$state$invoiceSu, _this$state$invoiceSu2;
      this.moreMenuOptions = [];
      if (!this.state.invoiceSummary.IsStatement && !this.state.routeParams.isFutureInvoice && this.state.isCurrentAccountPostpaid && !this.state.currentCustomerIsExternallyManagedAR && this.hasMakeAPaymentAccess() && this.invoiceSummary.CurrentDue >= 0) {
        this.moreMenuOptions.push({
          title: i18n.translate(this.LocaleKeys.MAKE_A_PAYMENT),
          id: DETAILS_CONSTANTS.MAKE_A_PAYMENT
        });
      }
      if (this.hasApplyTaxCertificateAccess() && ((_this$state$invoiceSu = this.state.invoiceSummary) === null || _this$state$invoiceSu === void 0 ? void 0 : _this$state$invoiceSu.WithheldTaxDue) > 0) {
        this.moreMenuOptions.push({
          title: i18n.translate(this.LocaleKeys.APPLY_TAX_CERTIFICATE.APPLY_TAX_CERTIFICATE),
          id: DETAILS_CONSTANTS.APPLY_TAX_CERTIFICATE
        });
      }
      ;
      if (this.invoiceSummary.CurrentDue < 0) {
        this.moreMenuOptions.push({
          title: i18n.translate(LocaleKeys.CONVERT_TO_CREDIT),
          id: DETAILS_CONSTANTS.CONVERT_TO_CREDIT
        });
      }
      if ((((_this$state$invoiceSu2 = this.state.invoiceSummary) === null || _this$state$invoiceSu2 === void 0 ? void 0 : _this$state$invoiceSu2.Receivables) || []).length) {
        this.moreMenuOptions.push({
          title: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.VIEW_RECEIVABLES),
          id: DETAILS_CONSTANTS.VIEW_RECEIVABLES
        });
      }
    }
  }, {
    key: "openApplyTaxCertificateModal",
    value: function openApplyTaxCertificateModal() {
      var _this3 = this;
      this.showApplyTaxCertificateModal = true;
      this.$timeout(function () {
        _this3.applyTaxCertificateModalApi.open();
      });
    }
  }, {
    key: "onApplyTaxCertificateModalClose",
    value: function onApplyTaxCertificateModalClose() {
      this.updatePage(1);
      this.applyTaxCertificateModalApi.close();
      this.showApplyTaxCertificateModal = false;
    }
  }, {
    key: "openConvertToCreditModal",
    value: function openConvertToCreditModal() {
      this.convertToCreditInitialValues = {
        AccountNumber: this.invoiceSummary.AccountNumber,
        noteType: BillingPaymentsConstants.CREDIT_NOTE_TYPE,
        InvoiceId: this.invoiceSummary.InvoiceId,
        InvoiceNumber: this.invoiceSummary.InvoiceNumber,
        Amount: Math.abs(this.invoiceSummary.CurrentDue),
        GenerateStatement: true
      };
      this.isConvertToCreditModalOpen = true;
    }
  }, {
    key: "handleMoreMenuOptions",
    value: function handleMoreMenuOptions(option) {
      switch (option.item.id) {
        case DETAILS_CONSTANTS.MAKE_A_PAYMENT:
          this.goToMakePayment();
          break;
        case DETAILS_CONSTANTS.APPLY_TAX_CERTIFICATE:
          this.openApplyTaxCertificateModal();
          break;
        case DETAILS_CONSTANTS.CONVERT_TO_CREDIT:
          this.openConvertToCreditModal();
          break;
        case DETAILS_CONSTANTS.VIEW_RECEIVABLES:
          this.openReceivablesModal(this.state.invoiceSummary.Receivables, this.state.invoiceSummary.CurrencyCode);
          break;
        default:
          break;
      }
    }
  }, {
    key: "openReceivablesModal",
    value: function openReceivablesModal(receivables, currency) {
      this.receivables = receivables;
      this.invoiceCurrency = currency;
      this.isReceivablesModalOpen = true;
    }
  }, {
    key: "onReceivablesModalClose",
    value: function onReceivablesModalClose() {
      this.isReceivablesModalOpen = false;
    }
  }, {
    key: "onConvertToCreditFormSubmit",
    value: function onConvertToCreditFormSubmit() {
      this.uiNotificationService.success(i18n.translate(LocaleKeys.CONVERT_TO_CREDIT_SUCCESS));
      this.isConvertToCreditModalOpen = false;
    }
  }, {
    key: "onConvertToCreditFormError",
    value: function onConvertToCreditFormError(message) {
      this.uiNotificationService.error(message);
    }
  }, {
    key: "handleConvertToCreditModalClose",
    value: function handleConvertToCreditModalClose() {
      this.isConvertToCreditModalOpen = false;
    }
  }, {
    key: "onSearchCleared",
    value: function onSearchCleared() {
      this.searchTerm = '';
      this.retrieveLedgerInvoiceDetails();
    }
  }, {
    key: "onSearchInvoiceItem",
    value: function onSearchInvoiceItem(invoiceNumber) {
      this.searchTerm = invoiceNumber;
      this.retrieveLedgerInvoiceDetails();
    }
  }, {
    key: "retrieveLedgerInvoiceDetails",
    value: function retrieveLedgerInvoiceDetails() {
      var _this4 = this;
      this.futureInvoiceHasError = false;
      this.invoiceDetailsRequest = {
        customerId: this.state.currentCustomerId,
        request: {
          InvoiceId: this.state.routeParams.invoiceId,
          PageNumber: this.state.pageNumber,
          PageSize: this.state.selectedPageSizePreference,
          InvoiceItemId: this.searchTerm || undefined
        }
      };
      return this.actions.retrieveLedgerInvoiceDetails(this.invoiceDetailsRequest).then(function () {
        _this4.updateInvoiceSummary();
        _this4.formatTableData();
        _this4.INVOICE_HEADER = _this4.state.routeParams.isFutureInvoice ? "".concat(i18n.translate(LocaleKeys.UPCOMING_INVOICE), " ").concat(_this4.invoiceBillDates) : "".concat(i18n.translate(LocaleKeys.INVOICE), ": ").concat(_this4.invoiceSummary.InvoiceNumber);
      }).catch(function (error) {
        if (_this4.state.routeParams.isFutureInvoice) {
          _this4.futureInvoiceHasError = true;
        }
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "updateInvoiceSummary",
    value: function updateInvoiceSummary() {
      var _this$state$invoiceSu3, _this$state$invoiceSu4;
      this.invoiceSummary = this.state.invoiceSummary && this.state.invoiceSummary !== {} && !this.state.routeParams.isFutureInvoice ? this.state.invoiceSummary : this.state.invoiceDetailsSummary;
      this.withheldTaxesApplicable = ((_this$state$invoiceSu3 = this.state.invoiceSummary) === null || _this$state$invoiceSu3 === void 0 ? void 0 : _this$state$invoiceSu3.TotalWithheldTax) > 0 || ((_this$state$invoiceSu4 = this.state.invoiceSummary) === null || _this$state$invoiceSu4 === void 0 ? void 0 : _this$state$invoiceSu4.TotalCashReceivable) > 0;
      this.amountDue = this.buildAmountDue();
      this.invoiceAmount = this.buildInvoiceAmount() || this.buildEstimatedAmount();
      this.invoiceBillDates = this.buildInvoiceBillDates();
    }
  }, {
    key: "onAdjustmentClose",
    value: function onAdjustmentClose() {
      this.adjustmentModalApi.close();
      this.showAdjustmentModal = false;
    }

    //Invoice adjustment has been removed from invoice.detail.page.html temporarily.
    //Below openInvoiceAdjustmentModal method is retained here, so that it can be easily reenabled in future when invoice adjustment is supported
  }, {
    key: "openInvoiceAdjustmentModal",
    value: function openInvoiceAdjustmentModal() {
      var _this5 = this;
      this.adjustmentType = BILL_ADJUSTMENT;
      this.adjustmentModal = {
        accountNumber: this.invoiceSummary.AccountNumber,
        maxAmount: this.invoiceSummary ? this.invoiceSummary.Amount : null,
        invoiceId: this.state.routeParams.invoiceId,
        referenceId: this.invoiceSummary.ReferenceId
      };
      this.showAdjustmentModal = true;
      this.$timeout(function () {
        _this5.adjustmentModalApi.open();
      });
    }
  }, {
    key: "retrieveInvoiceContent",
    value: function retrieveInvoiceContent() {
      if (this.state.routeParams.invoiceId) {
        this.actions.retrieveInvoiceAndOpenInNewTab(this.buildInvoiceContentRequest());
      }
    }
  }, {
    key: "buildAmountDue",
    value: function buildAmountDue() {
      this.isInvoiceAmountDueNegative = this.invoiceSummary.CurrentDue < 0;
      return this.invoiceSummary.CurrentDue !== null && this.invoiceSummary.CurrencyCode ? this.$filter('invCurrency')(this.invoiceSummary.CurrentDue, this.invoiceSummary.CurrencyCode) : null;
    }
  }, {
    key: "buildInvoiceAmount",
    value: function buildInvoiceAmount() {
      return this.invoiceSummary.Balance !== null && this.invoiceSummary.CurrencyCode ? this.$filter('invCurrency')(this.invoiceSummary.Balance, this.invoiceSummary.CurrencyCode) : null;
    }
  }, {
    key: "buildEstimatedAmount",
    value: function buildEstimatedAmount() {
      return this.invoiceSummary.EstimatedAmount !== null && this.invoiceSummary.EstimatedAmount ? this.$filter('invCurrency')(this.invoiceSummary.EstimatedAmount, this.invoiceSummary.CurrencyCode) : null;
    }
  }, {
    key: "buildBillingAndPaymentsRequest",
    value: function buildBillingAndPaymentsRequest() {
      return {
        customerId: this.state.currentCustomerId,
        request: {
          Filter: this.filter
        }
      };
    }
  }, {
    key: "buildInvoiceContentRequest",
    value: function buildInvoiceContentRequest() {
      return {
        customerId: this.state.currentCustomerId,
        customerName: this.state.currentCustomerName,
        invoiceNumber: this.invoiceSummary.InvoiceNumber,
        request: {
          InvoiceNumber: this.invoiceSummary.InvoiceNumber,
          InvoiceId: this.state.routeParams.invoiceId,
          IssueDate: this.invoiceSummary.IssueDate
        }
      };
    }
  }, {
    key: "buildInvoiceBillDates",
    value: function buildInvoiceBillDates() {
      var retVal = i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.NA);
      this.dueDate = this.invoiceSummary.DueDate ? this.$filter('localShortDate')(this.invoiceSummary.DueDate) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.NA);
      var sDate = this.invoiceSummary.StartDate ? this.$filter('localShortDate')(this.invoiceSummary.StartDate) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.NA);
      var eDate = this.invoiceSummary.EndDate ? this.$filter('localShortDate')(this.invoiceSummary.EndDate) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.NA);
      retVal = "".concat(sDate, " - ").concat(eDate);
      return retVal;
    }
  }, {
    key: "hasPaymentAdjustmentAccess",
    value: function hasPaymentAdjustmentAccess() {
      return hasAccess(this.state.userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS);
    }
  }, {
    key: "hasMakeAPaymentAccess",
    value: function hasMakeAPaymentAccess() {
      return hasAccess(this.state.userSecurityAttributes, ONE_TIME_MAKE_PAYMENT);
    }
  }, {
    key: "updatePage",
    value: function updatePage(page) {
      this.actions.updatePageNumber(page);
      this.retrieveLedgerInvoiceDetails();
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.updatePage(1);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      this.adjustmentModalApi.close();
    }
  }, {
    key: "formatTableData",
    value: function formatTableData() {
      var colDefs = _toConsumableArray(this.state.tableData.columnDefs);
      this.state.invoiceDetailsSummary.FutureInvoice ? colDefs.pop() : null;
      this.tableData = {
        data: this.state.tableData.data,
        columnDefs: colDefs
      };
    }
  }, {
    key: "goToMakePayment",
    value: function goToMakePayment() {
      this.actions.stateGo(MAKE_PAYMENT_ROUTE, {
        invoiceNumber: this.state.routeParams.invoiceId,
        paymentType: this.INVOICE_TYPE
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      var route = this.state.routeParams.isFutureInvoice ? this.defaultBackRoute : this.state.lastRoute.name || DASHBOARD_ROUTE;
      /**Added this change to fix back navigation issue when last route is make payment i.e to avoid the loop between make payment and invoice detail.
          Can think of better approach while we port to react. **/
      if (this.state.lastRoute.name === MAKE_PAYMENT_ROUTE) {
        this.$state.go(this.listPageRoute);
      } else {
        var params = this.state.lastRoute.params || {};
        this.$state.go(route, params);
      }
    }
  }]);
}();
export default {
  template: require('./views/invoice.detail.page.html'),
  controller: BillingPaymentsInvoiceController,
  controllerAs: 'billingPaymentsDetail'
};